<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item
          >新增客户</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>新增客户</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>客户姓名</p>
            <div class="input_box">
              <el-input
                v-model="formData.info_truename"
                placeholder="输入客户姓名"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>企业名称</p>
            <!-- <div class="input_box">
              <el-input
                v-model="formData.other_company"
                placeholder="输入企业名称"
              ></el-input>
            </div> -->
            <div class="select_box">
              <el-select
                v-model="formData.other_company"
                placeholder="输入企业名称"
                @visible-change="getCustomQyList"
              >
                <el-option
                  v-for="item in customerQy"
                  :key="item.id"
                  :label="item.bodyname"
                  :value="item.bodyname"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>职务</p>
            <div class="input_box">
              <el-input
                v-model="formData.other_job"
                placeholder="输入职务"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>联系方式</p>
            <div class="input_box">
              <el-input
                v-model="formData.info_mobile"
                placeholder="输入联系方式"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>客户标签</p>
            <div class="input_box">
              <el-radio-group v-model="formData.info_tag_id">
                <el-radio
                  border
                  v-for="item in customerOptin"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.labelname }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>

          <div class="block">
            <p>补充分类</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_type"
                placeholder="请选择补充分类"
                @visible-change="getQywxset('classid')"
              >
                <el-option
                  v-for="item in classidOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>客户属性</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_attr"
                placeholder="请选择客户属性"
                @visible-change="getQywxset('userattr')"
              >
                <el-option
                  v-for="item in userattrOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>联系优先度</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_yxd"
                placeholder="请选择联系优先度"
                @visible-change="getQywxset('contactsort')"
              >
                <el-option
                  v-for="item in contactsortOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>所在地区</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_province"
                placeholder="选择省/直辖市"
                @visible-change="getProvince"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.other_city"
                placeholder="选择城市"
                @visible-change="getCity"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.cityid"
                  :label="item.cityname"
                  :value="item.cityid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.other_area"
                placeholder="选择所在区域"
                @visible-change="getArea"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.addrid"
                  :label="item.addrname"
                  :value="item.addrid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.other_address"
                placeholder="请填写详细地址，50个字符内"
                type="textarea"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  getQywxset,
  getCustomerLabel,
  addCustomer
} from "../../api/api";
import { getCustomQyList } from "../../api/company";
export default {
  name: "addCustomer",
  data() {
    return {
      loading: false,
      qyguid: "",
      id: "",
      type: "",
      formData: {
        qyguid: '',
        ext_name: '',  // 客户昵称
        info_remark: "",  // 企业员工姓名
        info_truename: '',  // 客户真实姓名
        other_company: "",
        other_job: "",
        info_remark_mobiles: "",
        info_mobile: '',
        info_tag_id: "",
        other_type: "",
        other_attr: "",
        other_yxd: "",
        other_province: "",
        other_city: "",
        other_area: "",
        other_address: "",

        other_age: 0,
        score: 0,
      },

      classidOption: [], // 补充分类
      userattrOption: [], // 客户属性
      contactsortOption: [], // 联系优先度
      customerOptin: [], // 客户标签
      customerQy: [], // 企业

      provinceList: [],
      provinceTxtL: "",
      cityList: [],
      areaList: [],
    };
  },
  created() {
    this.qyguid = this.$store.state.USERINFO.qy.qyguid;
    this.formData.qyguid = this.$store.state.USERINFO.qy.qyguid
    this.getCustomerLabel();
  },
  methods: {
    // 获取客户标签
    getCustomerLabel() {
      let params = {
        pageindex: 1,
        pagesize: 100,
        keyword: "",
      };
      getCustomerLabel(params).then((res) => {
        this.customerOptin = res.list;
      });
    },

    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        this.provinceList = res;
        if (!isClick) {
          this.formData.other_city = "";
          this.formData.other_area = "";
          this.cityList = [];
          this.areaList = [];
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.formData.other_province).then((res) => {
        this.cityList = res;
        if (!isClick) {
          this.formData.other_area = "";
          this.areaList = [];
        }
      });
    },
    // 获取区域
    getArea() {
      getArea(this.formData.other_city).then((res) => {
        this.areaList = res;
      });
    },

    getQywxset(value) {
      getQywxset(value).then((res) => {
        if (value == "classid") {
          this.classidOption = res;
        } else if (value == "userattr") {
          this.userattrOption = res;
        } else if (value == "contactsort") {
          this.contactsortOption = res;
        }
      });
    },

    getCustomQyList() {
      getCustomQyList({ qyguid: this.qyguid }).then((res) => {
        this.customerQy = res.list;
      });
    },

    query() {
      let { formData } = this;
      if (formData.info_truename == "") {
        this.$message.warning("请输入客户姓名");
        return;
      }
    //   if (formData.other_company == "") {
    //     this.$message.warning("请输入企业名称");
    //     return;
    //   }
    //   if (formData.other_job == "") {
    //     this.$message.warning("请输入职务");
    //     return;
    //   }
      if (formData.info_mobile == "") {
        this.$message.warning("请输入联系方式");
        return;
      }
      this.loading = true;
      addCustomer(formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>